module.exports = __webpack_public_path__ + "img/marmelaedchen-presse_xs.a28cd411.jpg";